import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import xml2js from 'xml2js';
import * as cheerio from 'cheerio';
import Button from '@mui/material/Button';
import { importPO } from 'actions/EntityActions';
import { showError } from 'actions/CommonActions';
import { readPOExcel } from 'utils/helpers';
import ConfirmPODialog from './ConfirmPODialog';
import * as XLSX from 'xlsx';

class FileUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDialog: false,
      model: {},
      totalPriceMatch: false,
      POName: ""
    };
  }

  callback = (model) => {
    let subtotal = 0;
    model.Products && model.Products.map(item => { subtotal += item.totalPrice; });
    const today = new Date();
    this.props.purchaseOrderList.map(item => { if (item.subTotal != 0 && item.subTotal - subtotal < 0.2 && item.subTotal - subtotal > -0.2 && moment(today).diff(moment(item.creationDate), 'days') < 4) this.setState({ totalPriceMatch: true, POName: item.description }) });
    this.setState({ model: model, confirmDialog: true });
  }

  uploadFile = (e, callback) => {
    e.preventDefault();
    const THCul = ["THC", "THc", "Thc", "thc", "thC", "tHC", "tHc", "ThC", "tHc"];
    const CBDul = ["CBD", "CBd", "Cbd", "cbd", "cbD", "cBD", "cBd", "CbD", "cBd"];
    const branchId = this.props.branchId;

    try {
      if (this.props.province === "AB" || this.props.province === "Alberta") {
        let that = this;
        let file = e.target.files[0];
        if (file) {
          let ext = file.name.split('.')[1].toLowerCase();
          let reader = new FileReader();
          if (ext == 'htm' || ext == 'html') {
            reader.onload = (e) => readHtmlAB(e, callback, branchId, that);
          } else {
            let that = this;
            readPOExcel(e.target.files[0]).then((data) => {
              try {
                let invoiceNumber = '';
                let productArray = [];
                let allProductsAmount = 0;
                if (data.length > 0) {
                  invoiceNumber = data[0]["Order Number"];
                  console.log(invoiceNumber);
                  data.forEach((item, key) => {
                    let sku = item["SKU"].trim();
                    let unitPrice = item["Price Per Unit"] ? (item["Price Per Unit"]).replace('$', '') : '';
                    let quantity = item["Shipped Each Qty"];
                    let totalPrice = +(unitPrice * quantity).toFixed(2);
                    allProductsAmount += totalPrice;
                    let lotNumber = item["Lot Code"];
                    let UPC = (+item["Each GTIN"]).toString();
                    let model = {
                      SKU: sku,
                      quantity: quantity,
                      totalPrice: totalPrice,
                      lotNumber: lotNumber,
                      UPC: UPC
                    }
                    productArray.push(model);
                  });

                  let model = {
                    branchId: branchId,
                    vendor: 'AGLC',
                    shippingCost: 0,
                    GSTAmount: (allProductsAmount * 0.05).toFixed(2),
                    PSTAmount: 0,
                    HSTAmount: 0,
                    Products: productArray,
                    invoiceNumber: invoiceNumber,
                    invoiceDate: moment().format('YYYY-MM-DD')
                  }
                  callback(model);
                } else {
                  that.props.showError("No data found in PO file, please make sure you upload the PO file with excel format.");
                  return;
                }
              } catch (error) {
                console.log(error);
                that.props.showError("PO Import fail, please do a hard refresh, check and remove the extra line in the file then try importing again.");
                return;
              }
            });
          }
          reader.readAsArrayBuffer(file);
        }
      } else if (this.props.province === "BC" || this.props.province === "British Columbia") {
        let that = this;
        let file = e.target.files[0];
        if (file.name.split('.')[1] == 'xml') {
          let selectedFile = e.target.files[0];
          let reader = new FileReader();
          reader.onload = function (e) {
            try {
              var readXml = e.target.result;
              xml2js.parseString(readXml, function (err, result) {
                let productInfo = result.AdvanceShipmentNotice.ASNDetail[0].ListOfASNItemDetail[0].ASNItemDetail;
                let productArray = [];
                productInfo.map((item) => {
                  let lotNumberAndUPC = item.ASNBaseItemDetail[0].ItemIdentifiers[0].PartNumbers[0].OtherItemIdentifiers[0].ProductIdentifierCoded;
                  let lotNumber;
                  let UPC;
                  let unitsQuantity = item.ASNBaseItemDetail[0].ASNQuantities[0].ShippedQuantity[0].QuantityValue[0];
                  let quantityPerUnit = item.ASNBaseItemDetail[0].ASNQuantities[0].ListOfQuantityCoded[0].QuantityCoded[0].QuantityValue[0];
                  let quantity = unitsQuantity;
                  let totalPrice = (item.ASNLineItemListOfAllowOrCharge[0].AllowOrCharge[0].TypeOfAllowanceOrCharge[0].MonetaryValue[0].MonetaryAmount[0] * quantityPerUnit).toFixed(2);
                  let SKU = item.ASNBaseItemDetail[0].ItemIdentifiers[0].PartNumbers[0].SellerPartNumber[0].PartID[0];
                  if (lotNumberAndUPC[0].ProductIdentifierQualifierCoded == 'LotNumber') {
                    lotNumber = lotNumberAndUPC[0].ProductIdentifier[0];
                    UPC = (+lotNumberAndUPC[1].ProductIdentifier[0]).toString();
                  } else {
                    if (lotNumberAndUPC[1] !== null && lotNumberAndUPC[1] !== undefined) {
                      lotNumber = lotNumberAndUPC[1].ProductIdentifier[0];
                    }

                    UPC = (+lotNumberAndUPC[0].ProductIdentifier[0]).toString();
                  }
                  let model = {
                    lotNumber: lotNumber,
                    UPC: UPC,
                    quantity: quantity,
                    totalPrice: totalPrice,
                    SKU: SKU
                  }
                  productArray.push(model);
                });
                let headInfo = result.AdvanceShipmentNotice.ASNHeader[0].ASNOrderNumber[0];
                let invoiceNumber = headInfo.BuyerOrderNumber[0];
                let invoiceDate = moment(headInfo.PurchaseOrderDate[0]).format('YYYY-MM-DD');
                let model = {
                  branchId: branchId,
                  vendor: 'BC Cannabis Wholesale',
                  shippingCost: 0,
                  GSTAmount: 0,
                  PSTAmount: 0,
                  HSTAmount: 0,
                  Products: productArray,
                  invoiceNumber: invoiceNumber,
                  invoiceDate: moment(invoiceDate).format('YYYY-MM-DD')
                }
                console.log(model);
                callback(model);
              });
            } catch (error) {
              that.props.showError("PO Import fail, please do a hard refresh, check and remove the extra line in the file then try importing again.");
              return;
            }
          }
          reader.readAsText(selectedFile);
        } else {
          let reader = new FileReader();
          reader.readAsArrayBuffer(e.target.files[0]);
          reader.onload = function (e) {
            try {
              let data = new Uint8Array(reader.result);
              let wb = XLSX.read(data, { type: 'array' });
              let htmlstr = XLSX.write(wb, { sheet: wb.SheetNames[0], type: 'binary', bookType: 'csv' });
              let startIndex = 0;
              let endIndex = 0;
              let shippingCost = 0;
              let GSTAmount = 0;
              let PSTAmount = 0;
              let productArray = [];
              let invoiceNumber;
              let invoiceDate;
              let splitedCSV = htmlstr.split('\n');
              console.log(splitedCSV);
              for (let i = 0; i < splitedCSV.length; i++) {
                //get invoice #
                if (splitedCSV[i].indexOf('Invoice # :') != -1) {
                  let invoiceNumLine = splitedCSV[i];
                  let invoiceNumberIndex = invoiceNumLine.split(',').indexOf('Invoice # :') + 1;
                  invoiceNumber = invoiceNumLine.split(',')[invoiceNumberIndex];
                }
                //get payment date
                if (splitedCSV[i].indexOf('Invoice Date:') != -1) {
                  let invoiceDateLine = splitedCSV[i];
                  let invoiceDateIndex = invoiceDateLine.split(',').indexOf('Invoice Date:') + 1;
                  invoiceDate = invoiceDateLine.split(',')[invoiceDateIndex];
                }
                if (splitedCSV[i].indexOf('Product Description') != -1) {
                  startIndex = i + 1;
                }
                if (splitedCSV[i].indexOf('Total Extended Customer Price') != -1) {
                  endIndex = i - 1;
                }
                if (splitedCSV[i].indexOf('Freight Charges:') != -1) {
                  shippingCost = splitedCSV[i].split('$')[1].replace(/\D/g, '') / 100;
                }
                if (splitedCSV[i].indexOf('GST:') != -1 && splitedCSV[i].indexOf('$') != -1) {
                  GSTAmount = splitedCSV[i].split('$')[1].replace(/\D/g, '') / 100;
                }
                if (splitedCSV[i].indexOf('PST:') != -1) {
                  PSTAmount = splitedCSV[i].split('$')[1].replace(/\D/g, '') / 100;
                }
              }
              for (let i = startIndex; i < endIndex; i++) {
                let productData = splitedCSV[i].split(',');
                let SKU = productData[0];
                let productSize = productData[3];
                let Qty = productSize.split('X')[0] * productData[4];
                let totalDepositAmount = productData[5].replace(/\s/g, '');
                let singleDepositAmount = 0;
                let totalPrice = 0;
                if (totalDepositAmount != null && totalDepositAmount != '' && totalDepositAmount != undefined) {
                  singleDepositAmount = (totalDepositAmount.split('$')[1].replace(/\D/g, '') / 100) / Qty;
                  totalPrice = splitedCSV[i].split('$')[3].replace(/\D/g, '') / 100;
                } else {
                  totalPrice = splitedCSV[i].split('$')[2].replace(/\D/g, '') / 100;
                }
                if (SKU != null && SKU != undefined && SKU != "" && Qty > 0 && totalPrice > 0) {
                  if (productArray.some(p => p.SKU === SKU)) {
                    alert('po contains duplicate products, sku is: ' + SKU);
                    return;
                  }
                  let model = {
                    SKU: SKU,
                    quantity: Qty,
                    totalPrice: totalPrice,
                    depositAmount: singleDepositAmount.toFixed(2)
                  }
                  productArray.push(model);
                }
              }
              let model = {
                branchId: branchId,
                vendor: 'BC Cannabis Wholesale',
                shippingCost: shippingCost,
                GSTAmount: GSTAmount,
                PSTAmount: PSTAmount,
                HSTAmount: 0,
                Products: productArray,
                invoiceNumber: invoiceNumber,
                invoiceDate: moment(invoiceDate).format('YYYY-MM-DD')
              }
              //console.log(model);
              callback(model);
            } catch (error) {
              that.props.showError("PO Import fail, please do a hard refresh, check and remove the extra line in the file then try importing again.");
              return;
            }
          }
        }
      } else if (this.props.province === "Ontario" || this.props.province === "ON") {
        let that = this;
        readPOExcel(e.target.files[0]).then((data) => {
          try {
            let invoiceNumber = '';
            let productArray = [];
            let allProductsAmount = 0;
            if (data.length > 0) {
              // asn file
              if (data[0]["ShipmentID"]) {
                invoiceNumber = data[0]["ShipmentID"];
                data.forEach((item, key) => {
                  let sku = item["SKU"].trim();
                  let unitPrice = item["UnitPrice"] ? (item["UnitPrice"]).toString().replace('$', '') : '';
                  let quantity = item["Shipped_Qty"];
                  let totalPrice = +(unitPrice * quantity).toFixed(2);
                  allProductsAmount += totalPrice;
                  let lotNumber = item["BatchLot"];
                  let UPC = (+item["EachGTIN"]).toString();
                  let model = {
                    SKU: sku,
                    quantity: quantity,
                    totalPrice: totalPrice,
                    lotNumber: lotNumber,
                    UPC: UPC
                  }
                  productArray.push(model);
                });

              }
              // order confimration file
              else if (data[0]["FinalQtyAllocatedUnits"]) {
                invoiceNumber = "Order Confirmation Import";
                data.forEach((item, key) => {
                  let sku = item["SKU"].trim();
                  let unitPrice = item["WholesaleUnitPrice"] ? (item["WholesaleUnitPrice"]).toString().replace('$', '') : '';
                  let quantity = item["FinalQtyAllocatedUnits"];
                  let totalPrice = +(unitPrice * quantity).toFixed(2);
                  allProductsAmount += totalPrice;
                  let lotNumber = "";
                  let UPC = "";
                  let model = {
                    SKU: sku,
                    quantity: quantity,
                    totalPrice: totalPrice,
                    lotNumber: lotNumber,
                    UPC: UPC
                  }
                  productArray.push(model);
                });

              }
            } else {
              that.props.showError("No data found in PO file, please make sure you upload the PO file with excel format.");
              return;
            }

            let model = {
              branchId: branchId,
              vendor: 'Ontario Cannabis Retail Corporation',
              shippingCost: 0,
              GSTAmount: 0,
              PSTAmount: 0,
              HSTAmount: (allProductsAmount * 0.13).toFixed(2),
              Products: productArray,
              invoiceNumber: invoiceNumber,
              invoiceDate: moment().format('YYYY-MM-DD')
            }
            callback(model);
          } catch (error) {
            that.props.showError("PO Import fail, please do a hard refresh, check and remove the extra line in the file then try importing again." + error);
            return;
          }
        });
      } else if (this.props.province === "Manitoba" || this.props.province === "MB") {
        let that = this;
        let reader = new FileReader();
        reader.readAsArrayBuffer(e.target.files[0]);
        reader.onload = function (e) {
          try {
            let data = new Uint8Array(reader.result);
            let wb = XLSX.read(data, { type: 'array' });
            let htmlstr = XLSX.write(wb, { sheet: wb.SheetNames[0], type: 'binary', bookType: 'csv' });

            let productArray = [];
            let splitedCSV = htmlstr.split("\n");
            let invoiceNumber = '';
            let startIndex = 0;
            let endIndex = 0;
            let allProductsAmount = 0;

            if (splitedCSV[0].indexOf('Short Item Number') !== -1) {
              for (let i = 0; i < splitedCSV.length; i++) {
                let productData = splitedCSV[i].split(',');
                if (productData[0].trim() == '') {
                  endIndex = i;
                  break;
                }
              }

              for (let i = startIndex + 1; i < endIndex; i++) {
                let splitedData = splitedCSV[i].split(",");
                if (splitedData[0].trim() != '') {
                  let sku = splitedData[0];
                  let quantity = splitedData[3] * splitedData[4];
                  let totalPrice = (splitedData[6] ? splitedData[6].replace('$', '') : 0) * quantity;
                  let model = {
                    SKU: sku,
                    quantity: quantity,
                    totalPrice: totalPrice
                  }
                  productArray.push(model);
                  allProductsAmount += totalPrice;
                }
              }
            } else {
              for (let i = 0; i < splitedCSV.length; i++) {
                let productData = splitedCSV[i].split(',');
                if (productData[0] == 'SUPPLIER') {
                  startIndex = i;
                }

                if (startIndex > 0 && productData[0].trim() == '' && splitedCSV[i + 1].split(',')[0].trim() == '' && splitedCSV[i + 2].split(',')[0].trim() == '') {
                  endIndex = i;
                  break;
                }
              }

              for (let i = startIndex + 1; i < endIndex; i++) {
                let splitedData = splitedCSV[i].split(",");
                if (splitedData[0].trim() != '') {
                  let sku = splitedData[17];
                  let quantity = splitedData[13] * splitedData[18];
                  let totalPrice = (splitedData[15] ? splitedData[15].replace('$', '') : 0) * splitedData[18];
                  let model = {
                    SKU: sku,
                    quantity: quantity,
                    totalPrice: totalPrice
                  }
                  productArray.push(model);
                  allProductsAmount += totalPrice;
                }
              }
            }

            const model = {
              branchId: branchId,
              vendor: 'MBLL',
              shippingCost: 0,
              GSTAmount: (allProductsAmount * 0.05).toFixed(2),
              PSTAmount: 0,
              HSTAmount: 0,
              Products: productArray,
              invoiceNumber: invoiceNumber,
              invoiceDate: moment().format('YYYY-MM-DD')
            }
            callback(model);
          } catch (error) {
            that.props.showError("PO Import fail, please do a hard refresh, check and remove the extra line in the file then try importing again.");
            return;
          }
        }
      } else {
        alert("feature not ready for your province.");
      }
    } catch (err) {
      this.props.showError("PO Import fail, please do a hard refresh, check and remove the extra line in the file then try importing again.");
      return;
    }
  }

  closeDialog = () => {
    this.setState({ confirmDialog: false });
    this.setState({ totalPriceMatch: false, POName: "", model: {} });
  }

  createPO = () => {
    this.props.importPO(this.state.model);
    this.closeDialog();
  }

  render() {
    const styles = {
      uploadButton: this.props.buttonStyles,
      uploadInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: '2px',
        left: 0,
        width: '100%',
        opacity: 0
      }
    };
    return (
      <span>
        <Button
          variant="contained"
          component="span"
          id="importFromExcelXML"
          style={styles.uploadButton}
          color="primary"
          className={this.props.className}
        // disabled={this.props.disabled}
        >
          Import FROM EXCEL/XML/HTML
          <input
            className="fileInput"
            type="file"
            id="inputImportFromExcelXML"
            style={styles.uploadInput}
            onChange={(e) => this.uploadFile(e, this.callback)}
            onClick={(e) => (e.target.value = null)}
          />
          <ConfirmPODialog
            branchName={this.props.branchName}
            totalPriceMatch={this.state.totalPriceMatch}
            POName={this.state.POName}
            model={this.state.model}
            confirmDialog={this.state.confirmDialog}
            closeDialog={this.closeDialog}
            createPO={this.createPO}
          />
        </Button>
      </span>
    );
  }
}

function mapStatetoProps(state) {
  return {
    branchId: state.common.branchId,
    province: state.common.store.provinceState,
    branchName: state.common.store.name || '',
    purchaseOrderList: state.entity.purchaseOrderList || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    importPO: (model) => dispatch(importPO(model)),
    showError: (message) => dispatch(showError(message))
  }
}

let readHtmlAB = (event, callback, branchId, that) => {
  try {
    const decoder = new TextDecoder('utf-8');
    const htmlContent = decoder.decode(event.target.result);
    const $ = cheerio.load(htmlContent);

    let allProductsAmount = 0;
    let productArray = [];

    const oldFormat = $('#cart-item').length > 0;

    let orderNumber = '';

    console.log("Old Format: ", oldFormat);

    if (oldFormat) {
      // Old HTML structure
      $('#cart-item').each((index, element) => {
        const sku = $(element).find('#skuId').text().trim();
        const quantity = parseInt($(element).find('#itemQuantity').text());
        const pricePerCaseText = $(element).find('#pricePerCase').text().trim();
        const pricePerCase = parseFloat(pricePerCaseText.replace(/\$/g, ''));

        const allocatedText = $(element).find('.quantity-of-cases').text().trim();
        const allocatedMatch = /Allocated: (\d+)/.exec(allocatedText);
        const allocated = allocatedMatch ? parseInt(allocatedMatch[1]) : 0;

        if (allocated > 0) {
          const totalPrice = +(allocated * pricePerCase).toFixed(2);
          productArray.push({
            SKU: sku,
            quantity: +(quantity * allocated).toFixed(2),
            totalPrice: totalPrice
          });
          allProductsAmount += totalPrice;
        }
      });

      orderNumber = $('#orderNumber').first().text();
    } else {
      // New HTML structure

      // Extract all allocated numbers from full text first
      const allocatedList = [];
      $('body').text().replace(/Allocated:\s*(\d+)/g, (_, qty) => {
        allocatedList.push(parseInt(qty));
      });

      let allocIndex = 0;

      $('div.flex.w-full.items-center.gap-x-4.border-b.border-gray-300.py-5').each((index, element) => {
        const text = $(element).text();

        const skuMatch = text.match(/CNB-\d+/);
        const sku = skuMatch ? skuMatch[0] : null;

        const caseMatch = text.match(/Case of (\d+)/);
        const caseQty = caseMatch ? parseInt(caseMatch[1]) : 1;

        const priceMatch = text.match(/Price per case:\s*\$([\d.]+)/);
        const pricePerCase = priceMatch ? parseFloat(priceMatch[1]) : 0;

        if (sku && allocIndex < allocatedList.length) {
          const allocated = allocatedList[allocIndex++];
          const quantity = caseQty * allocated;
          const totalPrice = +(allocated * pricePerCase).toFixed(2);

          if (quantity > 0) {
            productArray.push({
              SKU: sku,
              quantity: quantity,
              totalPrice: totalPrice
            });
          }

          allProductsAmount += totalPrice;
        }
      });

      orderNumber = $('h3:contains("ORDER NUMBER")').text().split(':')[1]?.trim() || '';
    }

    let model = {
      branchId: branchId,
      vendor: 'AGLC',
      shippingCost: 0,
      GSTAmount: (allProductsAmount * 0.05).toFixed(2),
      PSTAmount: 0,
      HSTAmount: 0,
      Products: productArray,
      invoiceNumber: orderNumber,
      invoiceDate: moment().format('YYYY-MM-DD')
    };

    console.log(model);
    callback(model);
  } catch (error) {
    console.error("Error reading HTML file:", error);
    that.props.showError("PO Import failed, please do a hard refresh, check the file then try importing again. " + error);
    return;
  }
};

export default connect(mapStatetoProps, mapDispatchToProps)(FileUpload);
